var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"container-fluid col-xs-12 col-sm-12 col-md-12 col-lg-10"},[_c('div',{staticClass:"page-title"},[_c('h1',[_vm._v(_vm._s(_vm.$t(_vm.titleKey)))])]),_c('app-navigation',{attrs:{"navigation-buttons":_vm.navigationButtons}}),_c('valid-documents',{staticClass:"page-title"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }